<template>
    <div>
進入系統中
    </div>
</template>

<script>
    import {weixinSweepCode} from '../api/api'
    export default {
        data() {
            return {
                remarkStaffloading:false
            }
        },
        methods: {

        },
        mounted() {
        },
        computed: {

        },
        activated(){

        }
    }

</script>

<style lang="scss" scoped>
    .right{
        float: right;
    }
    .el-tag + .el-tag {
        margin-left: 1px;
        margin-top: 1px;
    }
</style>




// WEBPACK FOOTER //
// src/views/PdfUpdInfo.vue